import api from 'api/apiInstance';

export function adviceRoomGenerateTestSetupTokenApi(path: string) {
  return {
    path,
    POST: () => api.post<{ token: string }>(path),
  };
}
